// import { Injectable } from '@angular/core';
// import { ActivatedRouteSnapshot, ActivatedRoute, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
// import { Observable } from 'rxjs';
// import { LoginService } from './services/login.service';
// import * as _ from 'lodash'


// @Injectable({
//     providedIn: 'root'
// })
// export class ModuleGuard implements CanActivate {
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ActivatedRoute, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from './services/login.service';
import * as _ from 'lodash'

@Injectable({
    providedIn: 'root'
})

export class ModuleGuard implements CanActivate {
    constructor(private activeRoute: ActivatedRoute, private router: Router, private _loginService: LoginService) {
    }
    returnUrl;
    user;
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        const currentUser = this._loginService.currentUserValue;
        const user = this._loginService.userRolesValue;

        console.log('---------------------------------------', route.data.roles, currentUser, user);

        // if (user != null) {
        // let keys = Object.keys(user);
        if (route.data.permission) {
            let userPermissions = this._loginService.userPermissionValue;
            console.log('%croute.data.permission ', "color:DeepPink", route.data.permission)
            let compPermission = route.data.permission;
            let permissionData = Object.keys(userPermissions)
            console.log("userPermissions", userPermissions);
            console.log("this is permission data", permissionData);

            let temp = []
            compPermission.forEach(element => {

                if (permissionData.includes(element)) {
                    temp.push(element)
                }
            });


            console.log("what is temp", temp);
            if (temp && temp.length) {
                return true
            } else {
                console.log("first else portion");
                return false
            }
        } else {
            console.log("call rhuis else part");
            return false
        }
    }

}


